export default __webpack_public_path__ + "static/media/SearchGray.7ae0b259.svg";